import { ActionReducerMap } from '@ngrx/store';

import * as ui from './modules/shared/store/ui.reducer';
import * as user from './modules/user/store/user.reducer';

export interface AppState {
  ui: ui.UiState;
  user: user.UserState;
}

export const appReducers: ActionReducerMap<AppState> = {
  ui: ui.uiReducer,
  user: user.userReducer,
};
